var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ padding: '12px', minHeight: '360px' })},[_c('a-bread-crumb'),(_vm.belongsToOrg)?_c('a-dashboard-overview'):_c('a-no-tenant')],1)}
var staticRenderFns = []

export { render, staticRenderFns }